import React from 'react';

import { APPLY_LANGUAGES, translate } from './ApplyTranslations';

// SVG flags rather than emoji - Windows browsers don't render flag emoji.
function Flag({ code }) {
	let flagStyle = { width: '1.33em', height: '1em', marginRight: '.4em', verticalAlign: '-.1em', border: '1px solid #ddd' };
	return <img src={`${process.env.PUBLIC_URL}/img/flags/${code}.svg`} alt="" aria-hidden="true" style={flagStyle} />;
}

export default function ApplyLanguageSelect({ language, onChange }) {
	let current = APPLY_LANGUAGES.find((l) => l.code === language) || APPLY_LANGUAGES[0];
	let label = translate('apply.language', language);

	return (
		<div className="dropdown d-flex justify-content-end mb-2">
			<button
				className="btn btn-outline-secondary btn-sm dropdown-toggle"
				type="button"
				id="applyLanguageMenu"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
				aria-label={`${label}: ${current.nativeLabel}`}
				style={{ color: '#000', borderColor: '#888' }}
			>
				<Flag code={current.flag} />{current.nativeLabel}
			</button>
			<div className="dropdown-menu dropdown-menu-right" aria-labelledby="applyLanguageMenu">
				{APPLY_LANGUAGES.map((lang) => (
					<button
						key={lang.code}
						type="button"
						lang={lang.code}
						className={"dropdown-item" + (lang.code === language ? " active" : "")}
						aria-current={lang.code === language ? 'true' : undefined}
						onClick={() => onChange(lang.code)}
					>
						<Flag code={lang.flag} />{lang.nativeLabel}
					</button>
				))}
			</div>
		</div>
	);
}
